import { get_gallery_class_name, get_gallery_class_price, get_gallery_class_state } from './special.product.mobile.gallery.js';

var $grid; 
let productBasicSwiperItem = []; // 이미지 슬라이드에 필요함.
export default ({
    name : 'ProductBasic'
    , data () {
        return {
            productList : []
            , adminProductList : []
            , orderByClassName      : ''
            , orderBySelectedName   : '최신순'
            , orderBySelectedValue  : 'RECENT'
            , orderByOptionsOpened  : false
            , page : 1
            , limit : 10
            , limitAdmin : 10
            , limitDefAr : [10, 15, 30, 10]
            , isNext : false
            , displayTypeEnums : ['image','list','gallery','steps2']
            , hashTagConfig : {}
            , isFocus : false
			, getList : {
				'is_next' : false
				, 'list'  : []
				, 'phtConfig' : []
			}
        }
    }
    , created () {
        this.code = 'product_basic';
        this.basic = this.getDetailDataByCode(this.code);
        this.orderBySelectedValue = this.basic.data.order_by.value;
        this.orderBySelectedName = this.getOrderByName(this.basic.data.order_by.value);
        return {}
    }
    , mounted () {
        //선택했던 상품이 없다면 초기화 
        let getSelectPrdId = parseInt(sessionStorage.getItem('selectPrdId'));
        let listBack       = sessionStorage.getItem('listBack');
        let getList        = sessionStorage.getItem('getList');
        let pageType       = sessionStorage.getItem('pageType');

        if (getSelectPrdId == 0 || getList === null || getList == '' || pageType !== 'main') {
            sessionStorage.setItem('listBack', 'N');
            sessionStorage.setItem('pageType', 'main');
            sessionStorage.setItem('selectPrdId', 0);
            sessionStorage.setItem('getList', '');
            sessionStorage.setItem('listPage', this.page);
            sessionStorage.setItem('orderBy', this.orderBySelectedValue);
            sessionStorage.setItem('listType', this.getDisplayTypeValue()); /*18.04.27 수정 */
            sessionStorage.setItem('hashtag', 'all');
        }
        
        if (listBack !== 'N' || this.getAdminEditMode()) {
            window.addEventListener("load", this.getProductList);
        } else {
            if (typeof this.basic.data.default_list !== 'undefined') {
                this.setProductList(this.basic.data.default_list);
            }
        }
    }
    , computed : {
        isDisplayType1 () {
            return this.getDisplayTypeValue() == this.getDisplayTypeEnumValue(0)
        }
        , isDisplayType2 () {
            return this.getDisplayTypeValue() == this.getDisplayTypeEnumValue(1)
        }
        , isDisplayType3 () {
            return this.getDisplayTypeValue() == this.getDisplayTypeEnumValue(2)
        }
        , isDisplayType4 () {
            return this.getDisplayTypeValue() == this.getDisplayTypeEnumValue(3)
        }
        , isShowType1 () {
            return this.getShowTypeValue() == this.getShowTypeEnumValue(0)
        }
        , isShowType2 () {
            return this.getShowTypeValue() == this.getShowTypeEnumValue(1)
        }
        , isShowType3 () {
            return this.getShowTypeValue() == this.getShowTypeEnumValue(2)
        }
        , isOpenedOrderByOptions () {
            return this.orderByOptionsOpened;
        }
        , getHashTagConfig () {
            if (this.isChangedSearchHashTag() === true) {
				// 세션 초기화
				this.resetGetList();
                this.page = 1
                this.getProductList()
                vm.$store.commit('initProductSearchHashTag', {});
            }
            return this.hashTagConfig
        }
        , getDisplayProductList () {
            if (this.getAdminEditMode()) {
                return this.getDisplayAdminProductList()
            }
            return this.productList
        }
    }
    , methods : {
        get_gallery_class_name,
        get_gallery_class_price,
        get_gallery_class_state,
        getDisplayTypeValue () {
            return this.basic.data.display_type.value;
        }
        , getDisplayTypeEnumValue (key) {
            //return this.basic.data.display_type.enums[key];
            return this.displayTypeEnums[key]
        }
        , getOrderByEnums () {
            return this.basic.data.order_by.enums;
            //return this.orderByEnums
        }
        , getOrderByName (order) {
            if (order == 'RECENT'   ) { return '최신순'; }
            if (order == 'SELL_CNT' ) { return '판매순'; }
            if (order == 'LOW_PRICE') { return '낮은가격순'; }
			if (order == 'HIGH_REVIEW') { return '리뷰많은순'; }
			if (order == 'HIGH_GRADE') { return '평점높은순'; }
        }
		, getOrderByNameList (order) {            
			if (this.basic.data.order_by.value) { return view_item_list(order,this.productList) }
			return '';
        }
        , getOrerByClass (order) {
            if (this.basic.data.order_by.value == order) { return 'on'; }
            return '';
        }
        , getShowTypeValue () {
            return this.basic.data.show_type.value;
        }
        , getShowTypeEnumValue (key) {
            return this.basic.data.show_type.enums[key];
        }
        , getLimit () {
            let limits = this.limitDefAr
            let key = this.displayTypeEnums.indexOf(this.basic.data.display_type.value)
            return limits[key]
        }
        , isMultipleProductImage (imgList) {
            if (imgList.length > 1) return true; 
            return false;
        }
        , openOrderByOptions () {
			// 세션 초기화
			this.resetGetList();
            this.orderByOptionsOpened = (this.orderByOptionsOpened === false) ? true : false;
        }
		, resetGetList () {
			sessionStorage.setItem('getList', '');
			this.getList = {
				'is_next' : false
				, 'list'  : []
				, 'phtConfig' : []
			};
		}
        , getProductList () {
            if (this.getAdminEditMode() && this.page != 1) return

            this.keepListType();

            let isBack = sessionStorage.getItem('listBack');
			
			//뒤로가기 클릭시 session 저장한 리스트 보여주기
			if (this.getProductSearchHashTag()) {
				sessionStorage.setItem('hashtag', this.getProductSearchHashTag());
			}
			if (isBack === 'Y') {
				var getList  = JSON.parse(sessionStorage.getItem('getList'));
				this.setProductList(getList)
				this.$store.state.productSearchHashTag = sessionStorage.getItem('hashtag')
				return false
			}
			
            let params = new FormData()
            params.append('page', this.page)
            params.append('limit', this.getAdminEditMode() ? this.limitAdmin : this.getLimit())
            params.append('is_all', (isBack === 'Y') ? true : false)
            params.append('tag', this.getProductSearchHashTag())
            params.append('orderBy', this.orderBySelectedValue)
                
			this.$http.post(`${this.baseURI}/main/getList`, params, { headers : this.axiosCommonHeader }
            ).then(response => {
                if (typeof response.data == 'undefined') {
                    return
                }
                this.setProductList(response.data)
            }).catch(error => {
                //console.warn('ERROR!!! : ', error)
            })
        }
        , getPayUrl (productId, stockType) {
            if (this.getAdminEditMode()) {
                return 'javascript:void(0);'
            }
            return 'javascript:check_cart(' + productId + ');'
        }
        , goPayUrl (productId, stockType) {
            if (this.getAdminEditMode()) {
                return false
            }
            return check_cart(productId)
        }
        , getPayClass (stockType) {
            if (this.isSoldOutStockType(stockType)) {
                return 'btn-soldout'
            }
            return (viewCart) ? 'btn-buy' : 'btn-buy-100'
        }
		, getCartUrl (stockType) {
            if (this.isSoldOutStockType(stockType)) {
                return 'MSH-display-none'
            }
            return (viewCart) ? 'MSH-btn-cart-add' : 'MSH-display-none'
        }
        , getSoldoutClassName (stockType) {
            if (this.isSoldOutStockType(stockType)) return 'soldout'
            return ''
        }
        , isSoldOutStockType (stockType) {
            if (stockType == 'soldout') return true
            return false
        }
        , setProductList (data) {
            this.isNext = (data.is_next === true) ? true : false;
			// sessionStorage에 productList 저장
			this.getList['is_next'] = this.isNext;
			for (var i in data.list) {
				var list = data.list[i];
				this.getList['list'].push(list);
			}
			if (data.phtConfig.length !== 0 && typeof data.phtConfig == 'object' && typeof data.phtConfig.input == 'object') {
				this.getList['phtConfig'] = data.phtConfig;
			}			
			sessionStorage.setItem('getList', JSON.stringify(this.getList));
            if (this.page == 1) {
                this.productList = data.list
                this.adminProductList = data.list 
                if (typeof data.phtConfig == 'object' && typeof data.phtConfig.input == 'object') {
                    this.hashTagConfig = data.phtConfig
                }
            } else {
				if (sessionStorage.getItem('listBack') == 'Y' && typeof data.phtConfig == 'object' && typeof data.phtConfig.input == 'object') {
					this.hashTagConfig = data.phtConfig
					this.adminProductList = this.adminProductList.concat(data.list)
				}
                this.productList = this.productList.concat(data.list)
            }
            // adminEditMode scroll use
            if (this.getAdminEditMode()) {
                if ($m('#app').width() != $m('.wrap').width()) {
                    appChangedWidthFromAdmin()
                }
            } else {
                this.page += 1
                sessionStorage.setItem('listBack', 'N');

                // eachFocus
                this.$nextTick(function () {
                    if (parseInt(sessionStorage.getItem('selectPrdId')) > 0) {
                        this.productFocus();
                    }
                });
            }
        }
        , setOrderByClass (order) {
            this.orderBySelectedName = this.getOrderByName(order);
            this.orderBySelectedValue = order;
            this.openOrderByOptions();
            this.page = 1;
            this.getProductList();
			this.getOrderByNameList(order);
        }
        , setDisplayType (key) {
			// 세션 초기화
			this.resetGetList();
            //리스트 유지 시, 필요한 값 저장.
            sessionStorage.setItem('listType',  this.getDisplayTypeValue());
            sessionStorage.setItem('listPage',  Number(this.page) - 1);
			sessionStorage.setItem('orderBy', this.orderBySelectedValue);

            this.basic.data.display_type.value = this.getDisplayTypeEnumValue(key);
            this.page = 1;
            this.getProductList();
        }
        , swiperSlide () {
			$m('.visual-roll').each(function(i) {
                /*
                // return시 store data 변경되면 swiper pagination이벤트 적용안됨. 
				if ($m('.swiper-slide', $m(this)).length < 2) {
                    return;
                }
                */
                //$m(this).addClass('pb-35');     // img 위에 있으면 잘 안보임
                if (typeof productBasicSwiperItem[i] != 'undefined' && typeof productBasicSwiperItem[i].destroy == 'function') { 
                    productBasicSwiperItem[i].destroy(); 
                }
                let option = {
                    loop: true,
                    slidesPerView: 1,
                    pagination: {
                        el: '.swiper-pagination',
                    },
                    on: {
                        init: function () {
                            var swiper = this;
                            //$m(swiper.$el).find('.total').html('<em>1</em> / ' + $m(swiper.slides).not('.swiper-slide-duplicate').size());
                            if ($m(swiper.slides).not('.swiper-slide-duplicate').size() < 2) { // total 1개일경우 처리.
                                swiper.allowSlidePrev = false;
                                swiper.allowSlideNext = false;
                            }
                        },
                        slideChangeTransitionStart: function() {
                            //var swiper = this;
                            //var realIndex = parseInt($m(swiper.slides).eq(swiper.activeIndex).data('swiper-slide-index'), 10) + 1;
                            //$m(swiper.$el).find('.total em').text(realIndex);
                        }
                    }
                    , autoHeight : true
                }
                productBasicSwiperItem[i] = new Swiper(this, option);
			});
        }
        , imageGrid () {
			$grid = $m('.grid').masonry({
				itemSelector: '.grid-item',
				transitionDuration: '0.2s',
				columnWidth: $m('#list-type3').width() / 3
			});
			$grid.imagesLoaded().progress( function() {
				$grid.masonry('reloadItems').masonry('layout');
			});
        }
        , keepListType () {
            let listBack  = sessionStorage.getItem('listBack');
            let listType  = sessionStorage.getItem('listType');
            let listPage  = parseInt(sessionStorage.getItem('listPage'));
			let orderBy  = sessionStorage.getItem('orderBy');

            //listType값은 페이지를 이동할 때 생성
            if ((listBack === 'Y' && listType !== null) || document.referrer.indexOf('/cart/direct') !== -1) {
                if ($m.isNumeric(listPage) === false ) { listPage  = 1; }
                this.page  = listPage;
                this.basic.data.display_type.value = listType;
				this.orderBySelectedValue = orderBy;
				this.orderBySelectedName = this.getOrderByName(orderBy);
            } else {
                //리스트 유지 시, 필요한 값 저장.
                sessionStorage.setItem('listType',  this.getDisplayTypeValue());
                sessionStorage.setItem('listPage',  this.page);
				sessionStorage.setItem('orderBy', this.orderBySelectedValue);
            }
        }
        , imageSetHeight () {
            var targetImg = $m('.product-basic-steps2 li .img');
            targetImg.css({'height' : targetImg.width()});
        }
        , checkChangedLimitAr (setLimitAr) {
            let chk = false
            for (let k in setLimitAr) {
                if (this.limitDefAr.includes(setLimitAr[k]) === false) {
                    chk = true
                }
            }
            return chk
        }
        , getMaxLimitFromLimitAr (limitAr) {
            let maxLimit = 0
            for (let k in limitAr) {
                if (maxLimit < limitAr[k]) {
                    maxLimit = limitAr[k]
                }
            }
            return maxLimit
        }
        , getDisplayAdminProductList () {
            let limit = this.getLimit()
            let newList = []
            if (this.adminProductList.length < limit) return this.adminProductList
            for (let i=0; i<limit; i++) {
                newList[i] = this.adminProductList[i]
            }
            return newList
        }
        , updateList () {
            if (this.getDisplayTypeValue() == this.getDisplayTypeEnumValue(0)) { 
                this.swiperSlide()
            }
            if (this.getDisplayTypeValue() == 'gallery') { 
                this.imageGrid()
            }
            if (this.getDisplayTypeValue() == 'steps2') { 
                this.imageSetHeight()
            }
            if (this.getAdminEditMode() && this.isSetBasicData('product_limit') && this.basic.data.product_limit.value.length == 4) {
                if (this.checkChangedLimitAr(this.basic.data.product_limit.value)) {
                    this.limitDefAr = this.basic.data.product_limit.value
                    let maxLimit = this.getMaxLimitFromLimitAr(this.limitDefAr)
                    if (this.limitAdmin < maxLimit) {
                        this.limitAdmin = maxLimit
                        this.page = 1
                        this.getProductList()
                    }
                }
            }
            if (this.getAdminEditMode() && this.orderBySelectedName != this.basic.data.order_by.value) {
                this.orderBySelectedValue = this.basic.data.order_by.value
                this.orderBySelectedName = this.getOrderByName(this.basic.data.order_by.value)
            }
        }
		, productFocus : function(type) {
            let _vueThis = this;
			if (this.getDisplayTypeValue() == 'gallery') {
                $grid.imagesLoaded(function() {
                    _vueThis.eachFocus();
                });
                return;
            }
            _vueThis.eachFocus();
            return;
		}
		, eachFocus : function() {
			let selectPrdId = parseInt(sessionStorage.getItem('selectPrdId'));
            let _vueThis = this;
            if (selectPrdId < 1 || _vueThis.isFocus === true) { return false; }
			$m.each($m('.focusTag'), function(k, v) {
                let prdId = $m(this).data('prdId');
				if (prdId != selectPrdId) {
                    return true;
                }
                _vueThis.isFocus = true;
                sessionStorage.setItem('selectPrdId', 0); 
                window.history.pushState({prd_id:0}, 'main', '/');
                // ios
                if (mysoho.utility.isMobileIOS() === true) {
                    $m(this)[0].scrollIntoView(true); // true => top
                    // header 만큼 추가 이동.
                    $m('.wrap').scrollTop($m('.wrap').scrollTop() - $m('#header').outerHeight())
                    return false;
                }
                // android
                $m(this).focus(); // a tag
                $m(this).blur(); // a tag
                return false;
			});
		}
    }
    , updated () {
        this.updateList();
    }
})
